import { render, staticRenderFns } from "./dangerous.vue?vue&type=template&id=aa657c5e"
import script from "./dangerous.vue?vue&type=script&lang=js"
export * from "./dangerous.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports